import Settings16 from '@carbon/icons-react/es/settings/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { useHistory } from 'react-router';
import { Filter as FilterT } from 'api/notifications';
import { Button } from 'components/atoms/button';
import { FilterBar } from 'components/molecules/filter-bar';
import { useTranslation } from 'hooks/use-translation';

export interface Option<T> {
  label: string;
  value: T;
}

interface Props {
  selected: FilterT;
  options: Option<FilterT>[];
  onChange: (selected: FilterT) => void;
  configScreenUrl: string;
}

export const Filters: FC<Props> = ({
  selected,
  options,
  onChange,
  configScreenUrl,
}) => {
  const history = useHistory();
  const configuration = useTranslation('notifications.links.configuration');

  return (
    <FilterBar>
      <FilterBar.Primary>
        {options.map(({ value, label }) => (
          <FilterBar.Pill
            key={value}
            color={value === selected ? 'blue' : 'cool-gray'}
            onClick={(e) => {
              e.stopPropagation();
              onChange(value);
            }}
            hoverColor="blue"
          >
            {label}
          </FilterBar.Pill>
        ))}
      </FilterBar.Primary>
      <FilterBar.Secondary>
        <Tooltip title={configuration}>
          <Button
            type="text"
            aria-label={configuration}
            icon={<Settings16 />}
            onClick={() => history.push(configScreenUrl)}
          />
        </Tooltip>
      </FilterBar.Secondary>
    </FilterBar>
  );
};
